// extracted by mini-css-extract-plugin
export default {"controlButton":"zuIWH4","hidden":"C2VNys","overlay":"xI8eJ2","active":"OtdJ24","poster":"nXH0fq","icon":"ORYavv","transparency":"buyNP9"};